import styled from 'styled-components'

export const InputContainer = styled.div`
  width: 100%;
`
export const LoaderContainer = styled.div`
  &&&& {
    margin-top: 5px;
    text-align: right;
    background-color: #fff;
    width: 100%;
    padding: 5px;
    border: 1px solid #bdcbd0 !important;
    border-radius: 0.28571429rem;
    .loader::before,
    .loader::after,
    .loader {
      width: 1.5rem;
      height: 1.5rem;
      font-size: 12px;
    }
  }
`
